// File Metadata:
// Filename: authApiSlice.js
// Version: 1.00
// Created: 2022-09-27 23:50:09
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { apiSlice } from '../../app/api/apiSlice'
import { logOut, setCredentials } from '../auth/authSlice'
import { tokenService } from '../../services/tokenService'

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth',
                method: 'POST',
                body: { ...credentials }
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    console.log('Login successful:', data)
                    dispatch(setCredentials(data))
                    // Token is now handled by authSlice
                } catch (err) {
                    console.error('Login failed:', err)
                }
            }
        }),
        sendLogout: builder.mutation({
            query: () => ({
                url: '/auth/logout',
                method: 'POST'
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    console.log(data)

                    dispatch(logOut())
                    setTimeout(() => {
                        dispatch(apiSlice.util.resetApiState())
                    }, 1000)
                } catch (err) {
                    console.log(err)
                }
            }
        }),
        refresh: builder.mutation({
            query: () => ({
                url: '/auth/refresh',
                method: 'GET',
                credentials: 'include'
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    const { accessToken, ...userData } = data
                    console.log('Refresh success, setting credentials:', { accessToken, userData })
                    dispatch(setCredentials({ accessToken, ...userData }))
                } catch (err) {
                    console.log('Refresh failed:', err)
                }
            }
        }),
        imagekit: builder.mutation({
            query: () => ({
                url: '/auth/imagekit',
                method: 'GET'
            })
        })
    })
})

export const { useLoginMutation, useSendLogoutMutation, useRefreshMutation, useImagekitMutation } = authApiSlice
